import { render, staticRenderFns } from "./direct_charge.vue?vue&type=template&id=bdb97ca6&scoped=true&"
import script from "./direct_charge.vue?vue&type=script&lang=js&"
export * from "./direct_charge.vue?vue&type=script&lang=js&"
import style0 from "./direct_charge.vue?vue&type=style&index=0&id=bdb97ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb97ca6",
  null
  
)

export default component.exports